// extracted by mini-css-extract-plugin
export default {"avatar":"ekpDiYnT","circular":"ZxcWjCt2"};